export { Skeleton } from './skeleton';
export type {
  SkeletonAvatarProps,
  SkeletonGroupProps,
  SkeletonListPlayerHeaderProps,
  SkeletonLineProps,
  SkeletonPlayerCardProps,
  SkeletonProps,
} from './skeleton';
